import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { categoryEmoji } from '../categoryEmoji';
import { getCachedData, refreshCache } from '../store';
import CategoryForm from './CategoryForm';

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);

  const loadData = async () => {
    const cats = await api.getCategories();
    setCategories(cats);
  };

  useEffect(() => {
    // Мгновенно показываем данные из памяти браузера, затем обновляем из JSON
    const cached = getCachedData();
    if (cached && Array.isArray(cached.categories)) setCategories(cached.categories);
    loadData();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Удалить категорию? Транзакции с этой категорией останутся, но будут без категории.')) {
      await api.deleteCategory(id);
      loadData();
      refreshCache();
    }
  };

  return (
    <div className="content">
      <h1>Категории</h1>
      <button onClick={() => { setShowForm(true); setEditingCategory(null); }}>+ Новая категория</button>
      {showForm && (
        <CategoryForm
          category={editingCategory}
          onSave={async (data) => {
            if (editingCategory) {
              await api.updateCategory(editingCategory.id, data);
            } else {
              await api.createCategory(data);
            }
            setShowForm(false);
            loadData();
            refreshCache();
          }}
          onCancel={() => setShowForm(false)}
        />
      )}
      <h2 className="section-title">Доходы</h2>
      <ul className="list">
        {categories.filter(c => c.type === 'income').map(c => (
          <li key={c.id} className="list-item">
            <div className="list-item-left">
              <span className="cat-icon">{categoryEmoji(c.name)}</span>
              <span className="list-item-title">{c.name}</span>
            </div>
            <div className="actions">
              <button className="small-icon" onClick={() => { setEditingCategory(c); setShowForm(true); }}>✏️</button>
              <button className="small-icon danger" onClick={() => handleDelete(c.id)}>🗑️</button>
            </div>
          </li>
        ))}
      </ul>
      <h2 className="section-title">Расходы</h2>
      <ul className="list">
        {categories.filter(c => c.type === 'expense').map(c => (
          <li key={c.id} className="list-item">
            <div className="list-item-left">
              <span className="cat-icon">{categoryEmoji(c.name)}</span>
              <span className="list-item-title">{c.name}</span>
            </div>
            <div className="actions">
              <button className="small-icon" onClick={() => { setEditingCategory(c); setShowForm(true); }}>✏️</button>
              <button className="small-icon danger" onClick={() => handleDelete(c.id)}>🗑️</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
